import { ID, Int } from '@adornis/baseql/baseqlTypes.js';
import { registerMutation, registerQuery, registerSubscription } from '@adornis/baseql/metadata/register.js';
import { ExamSlotRatingDoc } from '../db/rating.js';
import {
  commitRatingDocResolver,
  getCommittedRatingsOlderThanXDaysResolver,
  getRatingsBySlotIDResolver,
  getUncommittedRatingResolver,
  subscribeAllNonFinalRatingsByRatingIDResolver,
  subscribeAndCreateMyRatingDocForSlotResolver,
  subscribeFinalRatingDocForSlotResolver,
  subscribeRatingDocForSlotResolver,
  subscribeRatingDocsForSlotResolver,
  updateInstructionNoteResolver,
  updateInstructionScoreOfRatingDocResolver,
  updateRatingNoteResolver,
} from '../server/resolver/ratings.js';

export const getUncommittedRating = registerQuery({
  operationName: 'getUncommittedRating',
  resolve: getUncommittedRatingResolver,
  type: () => ExamSlotRatingDoc,
  params: [],
});

export const subscribeAllNonFinalRatingsByRatingID = registerSubscription({
  operationName: 'subscribeAllNonFinalRatingsByRatingID',
  resolve: subscribeAllNonFinalRatingsByRatingIDResolver,
  type: () => [ExamSlotRatingDoc],
  params: [{ name: 'ratingID', type: () => String }],
});

export const getRatingsBySlotID = registerQuery({
  operationName: 'getRatingsBySlotID',
  resolve: getRatingsBySlotIDResolver,
  type: () => [ExamSlotRatingDoc],
  params: [{ name: 'slotID', type: () => ID }],
});

export const subscribeAndCreateMyRatingDocForSlot = registerSubscription({
  operationName: 'subscribeAndCreateMyRatingDocForSlot',
  resolve: subscribeAndCreateMyRatingDocForSlotResolver,
  type: () => ExamSlotRatingDoc,
  params: [{ name: 'slotID', type: () => ID }],
});

export const subscribeRatingDocForSlot = registerSubscription({
  operationName: 'subscribeRatingDocForSlot',
  resolve: subscribeRatingDocForSlotResolver,
  type: () => ExamSlotRatingDoc,
  params: [
    { name: 'slotID', type: () => ID },
    { name: 'userID', type: () => ID },
  ],
});

export const subscribeFinalRatingDocForSlot = registerSubscription({
  operationName: 'subscribeFinalRatingDocForSlot',
  resolve: subscribeFinalRatingDocForSlotResolver,
  type: () => ExamSlotRatingDoc,
  params: [{ name: 'slotID', type: () => ID }],
});

export const subscribeRatingDocsForSlot = registerSubscription({
  operationName: 'subscribeRatingDocsForSlot',
  resolve: subscribeRatingDocsForSlotResolver,
  type: () => [ExamSlotRatingDoc],
  params: [{ name: 'slotID', type: () => ID }],
});

export const updateInstructionScoreOfRatingDoc = registerMutation({
  operationName: 'updateInstructionScoreOfRatingDoc',
  resolve: updateInstructionScoreOfRatingDocResolver,
  type: () => Boolean,
  params: [
    { name: 'ratingID', type: () => ID },
    { name: 'instructionID', type: () => ID },
    { name: 'score', type: () => Int },
  ],
});

export const commitRatingDoc = registerMutation({
  operationName: 'commitRatingDoc',
  resolve: commitRatingDocResolver,
  type: () => Boolean,
  params: [{ name: 'ratingID', type: () => ID }],
});

export const updateRatingNote = registerMutation({
  operationName: 'updateRatingNote',
  resolve: updateRatingNoteResolver,
  type: () => Boolean,
  params: [
    { name: 'ratingID', type: () => ID },
    { name: 'note', type: () => String },
  ],
});

export const updateInstructionNote = registerMutation({
  operationName: 'updateInstructionNote',
  resolve: updateInstructionNoteResolver,
  type: () => Boolean,
  params: [
    { name: 'ratingID', type: () => ID },
    { name: 'instructionID', type: () => ID },
    { name: 'note', type: () => String },
  ],
});

export const getCommittedRatingsOlderThanXDays = registerQuery({
  operationName: 'getCommittedRatingsOlderThanXDays',
  resolve: (days: number) => getCommittedRatingsOlderThanXDaysResolver(days),
  type: () => [ExamSlotRatingDoc],
  params: [{ name: 'days', type: () => Int }],
});
